/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Action from './Action/index'
import ProfileActions from 'DesignSystem/ProfileActions/index'
import React from 'react'
import RescheduleAction from './RescheduleAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/ActionsDialog/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let eventAppointmentPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient._id',
})
let eventAppointmentPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient.person',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let constantData = 'SCHEDULED'
let eventStateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let aggregateData = fromHelpers.shouldShow(constantData, eventStateValueData)
let eventStateValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let eventConfirmationStatusValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'confirmation_status',
})
let aggregateData1 = fromHelpers.shouldShowConfirmed(eventStateValueData1, eventConfirmationStatusValueData)
let eventStateValueData2 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData1 = 'SCHEDULED'
let constantData2 = 'CHECKED_IN'
let aggregateData2 = fromHelpers.shouldShow(eventStateValueData2, constantData1, constantData2)
let eventStateValueData3 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData3 = 'SCHEDULED'
let constantData4 = 'CONFIRMED'
let constantData5 = 'PATIENT_CANCELLED'
let constantData6 = 'OFFICE_CANCELLED'
let constantData7 = 'NO_SHOW'
let aggregateData3 = fromHelpers.shouldShow(eventStateValueData3, constantData3, constantData4, constantData5, constantData6, constantData7)
let eventStateValueData4 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData8 = 'SCHEDULED'
let aggregateData4 = fromHelpers.shouldShow(eventStateValueData4, constantData8)
let eventStateValueData5 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData9 = 'SCHEDULED'
let aggregateData5 = fromHelpers.shouldShow(eventStateValueData5, constantData9)
let eventStateValueData6 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData10 = 'CHECKED_IN'
let aggregateData6 = fromHelpers.shouldShow(eventStateValueData6, constantData10)
let eventStateValueData7 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData11 = 'CHECKED_IN'
let aggregateData7 = fromHelpers.shouldShow(eventStateValueData7, constantData11)
let eventStateValueData8 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData12 = 'SEATED'
let aggregateData8 = fromHelpers.shouldShow(eventStateValueData8, constantData12)
let eventStateValueData9 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData13 = 'SEATED'
let aggregateData9 = fromHelpers.shouldShow(eventStateValueData9, constantData13)
let eventStateValueData10 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData14 = 'SEATED'
let aggregateData10 = fromHelpers.shouldShow(eventStateValueData10, constantData14)
let eventStateValueData11 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData15 = 'SEATED'
let constantData16 = 'UNSEATED'
let aggregateData11 = fromHelpers.shouldShow(eventStateValueData11, constantData15, constantData16)
let eventStateValueData12 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData17 = 'UNSEATED'
let constantData18 = 'CHECKED_OUT'
let aggregateData12 = fromHelpers.shouldShow(eventStateValueData12, constantData17, constantData18)
let eventStateValueData13 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData19 = 'PATIENT_CANCELLED'
let constantData20 = 'OFFICE_CANCELLED'
let constantData21 = 'NO_SHOW'
let aggregateData13 = fromHelpers.shouldShow(eventStateValueData13, constantData19, constantData20, constantData21)
let eventStateValueData14 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData22 = 'PATIENT_CANCELLED'
let constantData23 = 'OFFICE_CANCELLED'
let constantData24 = 'NO_SHOW'
let aggregateData14 = fromHelpers.shouldShow(eventStateValueData14, constantData22, constantData23, constantData24)
let eventStateValueData15 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData25 = 'PATIENT_CANCELLED'
let constantData26 = 'OFFICE_CANCELLED'
let constantData27 = 'NO_SHOW'
let aggregateData15 = fromHelpers.shouldShow(eventStateValueData15, constantData25, constantData26, constantData27)
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-5-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-6-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<ProfileActions
  viewPath={`${viewPath}/ProfileActions`}
 data="event.appointment.patient._id"
 patient_id={eventAppointmentPatientIdValueData}
 data="event.appointment.patient.person"
 person={eventAppointmentPatientPersonValueData}
 color={dtColorsNeutral900}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Appointment Actions"
 color={dtColorsNeutral400}
 weight="medium"
 size="normal"
/>
<fromFlow.When is={aggregateData}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Check in patient"
 data="'SCHEDULED'"
 data="event.state"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData1}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Mark as confirmed"
 data="event.state"
 data="event.confirmation_status"
 aggregate="helpers.js shouldShowConfirmed"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData2}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Print appointment Slip"
 data="event.state"
 data="'SCHEDULED'"
 data="'CHECKED_IN'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<RescheduleAction
  viewPath={`${viewPath}/RescheduleAction`}
/>
<fromFlow.When is={aggregateData3}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Add to reschedule queue"
 data="event.state"
 data="'SCHEDULED'"
 data="'CONFIRMED'"
 data="'PATIENT_CANCELLED'"
 data="'OFFICE_CANCELLED'"
 data="'NO_SHOW'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData4}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Mark as No Show"
 data="event.state"
 data="'SCHEDULED'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData5}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Cancel appointment"
 data="event.state"
 data="'SCHEDULED'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData6}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Seat"
 data="event.state"
 data="'CHECKED_IN'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData7}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Cancel check-in"
 data="event.state"
 data="'CHECKED_IN'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData8}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Extend appointment time"
 data="event.state"
 data="'SEATED'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData9}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Shorten appointment time"
 data="event.state"
 data="'SEATED'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData10}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Unseat"
 data="event.state"
 data="'SEATED'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData11}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Cancel Seating"
 data="event.state"
 data="'SEATED'"
 data="'UNSEATED'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData12}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Check Out"
 data="event.state"
 data="'UNSEATED'"
 data="'CHECKED_OUT'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData13}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Schedule via SMS"
 data="event.state"
 data="'PATIENT_CANCELLED'"
 data="'OFFICE_CANCELLED'"
 data="'NO_SHOW'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData14}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Schedule via Email"
 data="event.state"
 data="'PATIENT_CANCELLED'"
 data="'OFFICE_CANCELLED'"
 data="'NO_SHOW'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
<fromFlow.When is={aggregateData15}>
<Action
  viewPath={`${viewPath}/Action`}
 mocked={true}
 text="Delete appointment"
 data="event.state"
 data="'PATIENT_CANCELLED'"
 data="'OFFICE_CANCELLED'"
 data="'NO_SHOW'"
 aggregate="helpers.js shouldShow"
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}